// React

import Welcome from './pages/Welcome'

import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';


import './scss/main.scss'

//      <Timelapse />
//      <Welcome />
class Wrapper extends React.Component {
  render(){
    return (
      <Welcome />
    )
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Wrapper />
  </React.StrictMode>
);
